import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import About from './About';
import snake from './img/infinity.gif';
import './css/App.css';

class Dapp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: "0.0",
      text: "",
      receipt: null,
      processing: false
    }
    this.text = null;
  }

  componentDidMount() {
    var self = this;
    setTimeout(() => {
      self.text.focus();
    }, 500);

  }

  render() {
    return (
      <div>
        {/*<About />*/}
        <button className="close-btn" onClick={this._close.bind(this)}><span className="close thick"></span></button>
        {this.state.receipt ?
          <div className="full full-paper flex">
            <div className="done">
              <h1>Saved Forever</h1>
              <div>
                <Link className="view" to={"/posts/"+this.state.receipt}>View Post</Link><br />
                <a className="view" href={"https://etherscan.io/tx/"+this.state.receipt} target="_blank" rel="noopener noreferrer">View on EtherScan</a>
                <div className="note">Click "View Input As" and choose "UTF-8"</div>
              </div>
            </div>
          </div>
          :
          <div className="full full-paper">
            <textarea ref={(input) => { this.text = input; }} onKeyUp={this._updateText.bind(this)} placeholder="Type your message here to have it saved permanently to the Ethereum blockchain..."></textarea>
            <button className={this.state.text === "" ? "submit disabled" : "submit"} onClick={this._submit.bind(this)}>Save Forever</button>
            {
              this.state.processing ?
                <div className="processing flex">
                  <div className="galaxy"></div>
                  <div className="processing-inner">
                    <img className="snake" src={snake} alt="Forever" />
                    <div>Waiting on MetaMask...</div>
                  </div>
                </div>
              : null
            }
          </div>
        }
      </div>
    );
  }

  _close() {
    this.props.close();
  }

  _updateText() {
    if(this.text) {
      const text = this.text.value;
      //if(text !== null && text.trim() !== "") {
        this.setState({text: text});
      //}
    }
  }

  _submit = async (event) => {
    const text = this.text.value;
    if(text.length === 0) {
      return;
    }
    this.setState({processing: true, text: text});
    console.log("value", text);



    const accounts = await this.props.web3.eth.getAccounts();
    console.log('your address: ' + accounts[0]);


    let txTransfer = {};
    txTransfer.from = accounts[0];
    txTransfer.to = window.to;
    txTransfer.value = this.props.web3.utils.toWei(this.state.amount, "ether");
    txTransfer.data = this.props.web3.utils.toHex("\n" + text);
    console.log("data", txTransfer.data);


    const gasEstimate = await this.props.web3.eth.estimateGas({
      from: accounts[0],
      to: window.to,
      amount: this.props.web3.utils.toWei(this.state.amount, "ether"),
      data: txTransfer.data
    });
    console.log("estiamted gas: " + gasEstimate);
    txTransfer.gas = gasEstimate;

    const gasPrice = await this.props.web3.eth.getGasPrice();
    console.log("gas price: " + gasPrice);
    txTransfer.gasPrice = gasPrice;


    var self = this;
    this.props.web3.eth.sendTransaction(txTransfer)
      .on('transactionHash', function(hash){
        console.log("hash");
        console.log(hash);
        self.setState({receipt: hash});
      })
      .on('error', function(error) {
        console.log("Transaction error");
        self.setState({processing: false});
        return;
      });

  }
}

export default Dapp;



// WEBPACK FOOTER //
// ./src/Dapp.js